import { render, staticRenderFns } from "./ResetPasswordDone.vue?vue&type=template&id=ed7c3690&scoped=true&"
import script from "./ResetPasswordDone.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordDone.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordDone.vue?vue&type=style&index=0&id=ed7c3690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7c3690",
  null
  
)

export default component.exports